import {
  GET_TECHNICIANS,
  GET_TECHNICIANS_SUCCESS,
  GET_TECHNICIANS_ERROR,
  ADD_TECHNICIAN,
  ADD_TECHNICIAN_SUCCESS,
  ADD_TECHNICIAN_ERROR,
  GET_TECHNICIAN,
  GET_TECHNICIAN_SUCCESS,
  GET_TECHNICIAN_ERROR,
  UPDATE_TECHNICIAN,
  UPDATE_TECHNICIAN_SUCCESS,
  UPDATE_TECHNICIAN_ERROR,
  DELETE_TECHNICIAN,
  DELETE_TECHNICIAN_SUCCESS,
  DELETE_TECHNICIAN_ERROR,
  TOGGLE_TECHNICIAN_MODAL,
  TOGGLE_TECHNICIAN_BLOCk_MODAL,
  UPDATE_BLOCK_STATUS,
  UPDATE_BLOCK_STATUS_SUCCESS,
  UPDATE_BLOCK_STATUS_ERROR,
  GET_TECHNICIAN_PURCHASES,
  GET_TECHNICIAN_PURCHASES_SUCCESS,
  GET_TECHNICIAN_PURCHASES_ERROR,
  CHANGE_TECHNICIAN_REMAINING_CALLS,
  CHANGE_TECHNICIAN_REMAINING_CALLS_SUCCESS,
  CHANGE_TECHNICIAN_REMAINING_CALLS_ERROR,
} from "./actionTypes";

export const getTechnicians = (request) => {
  return {
    type: GET_TECHNICIANS,
    payload: { request },
  };
};

export const getTechniciansSuccess = (paginatedCustomers) => {
  return {
    type: GET_TECHNICIANS_SUCCESS,
    payload: paginatedCustomers,
  };
};

export const getTechniciansError = (message) => {
  return {
    type: GET_TECHNICIANS_ERROR,
    payload: message,
  };
};

export const addTechnician = (request) => {
  return {
    type: ADD_TECHNICIAN,
    payload: { request },
  };
};

export const addTechnicianSuccess = () => {
  return {
    type: ADD_TECHNICIAN_SUCCESS,
  };
};

export const addTechnicianError = (error) => {
  return {
    type: ADD_TECHNICIAN_ERROR,
    payload: error,
  };
};

export const getTechnician = (id) => {
  return {
    type: GET_TECHNICIAN,
    payload: { id },
  };
};

export const getTechnicianSuccess = (customer) => {
  return {
    type: GET_TECHNICIAN_SUCCESS,
    payload: customer,
  };
};

export const getTechnicianError = (message) => {
  return {
    type: GET_TECHNICIAN_ERROR,
    payload: message,
  };
};

export const updateTechnician = (request) => {
  return {
    type: UPDATE_TECHNICIAN,
    payload: { request },
  };
};

export const updateTechnicianSuccess = () => {
  return {
    type: UPDATE_TECHNICIAN_SUCCESS,
  };
};

export const updateTechnicianError = (error) => {
  return {
    type: UPDATE_TECHNICIAN_ERROR,
    payload: error,
  };
};

export const deleteTechnician = (id) => {
  return {
    type: DELETE_TECHNICIAN,
    payload: { id },
  };
};

export const deleteTechnicianSuccess = () => {
  return {
    type: DELETE_TECHNICIAN_SUCCESS,
  };
};

export const deleteTechnicianError = (error) => {
  return {
    type: DELETE_TECHNICIAN_ERROR,
    payload: error,
  };
};

export const toggleTechnicianModalAction = () => {
  return {
    type: TOGGLE_TECHNICIAN_MODAL,
  };
};

export const updateBlockStatus = (request) => {
  return {
    type: UPDATE_BLOCK_STATUS,
    payload: { request },
  };
};

export const updateBlockStatusSuccess = () => {
  return {
    type: UPDATE_BLOCK_STATUS_SUCCESS,
  };
};

export const updateBlockStatusError = (error) => {
  return {
    type: UPDATE_BLOCK_STATUS_ERROR,
    payload: error,
  };
};

export const toggleTechnicianBlockModalAction = () => {
  return {
    type: TOGGLE_TECHNICIAN_BLOCk_MODAL,
  };
};

export const getTechnicianPurchases = (id) => {
  return {
    type: GET_TECHNICIAN_PURCHASES,
    payload: { id },
  };
};

export const getTechnicianPurchasesSuccess = (purchases) => {
  return {
    type: GET_TECHNICIAN_PURCHASES_SUCCESS,
    payload: purchases,
  };
};

export const getTechnicianPurchasesError = (message) => {
  return {
    type: GET_TECHNICIAN_PURCHASES_ERROR,
    payload: message,
  };
};

export const changeTechnicianRemainingCalls = (request) => {
  return {
    type: CHANGE_TECHNICIAN_REMAINING_CALLS,
    payload: { request },
  };
};

export const changeTechnicianRemainingCallsSuccess = (response) => {
  return {
    type: CHANGE_TECHNICIAN_REMAINING_CALLS_SUCCESS,
    payload: response,
  };
};

export const changeTechnicianRemainingCallsError = (message) => {
  return {
    type: CHANGE_TECHNICIAN_REMAINING_CALLS_ERROR,
    payload: message,
  };
};
